// extracted by css-extract-rspack-plugin
var _1 = "Ud6w_YMTxcr09jGg";
var _2 = "e6cZ4tBP0sQ2JBvv";
var _3 = "Ud6w_YMTxcr09jGg";
var _4 = "e6cZ4tBP0sQ2JBvv";
var _5 = "b_ZNQePnEYOj9Uz0";
var _6 = "U1pn7jDPrsqLg9Hx";
var _7 = "QEuPcrkqtkfujlew";
var _8 = "QEuPcrkqtkfujlew";
var _9 = "HoUvZ6ggE80u_kR2";
var _a = "uo53bgYtcLAzMGXe";
var _b = "uo53bgYtcLAzMGXe";
export { _1 as "box-price", _2 as "box-text", _3 as "boxPrice", _4 as "boxText", _5 as "button", _6 as "cta", _7 as "cta-text", _8 as "ctaText", _9 as "price", _a as "price-wrapper", _b as "priceWrapper" }
